import { calendarDateFormat } from 'constant/formats';
import dayjsInstance from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjsInstance.extend(customParseFormat);
dayjsInstance.extend(calendar);

export const todayDate = dayjsInstance();
export const currentYear = dayjsInstance().year();

export const returnDate = (date: string | Date, inputFormat?: string) =>
  dayjsInstance(date, inputFormat);

export const formatHandler = (
  data: string | Date,
  inputFormat: string,
  outputFormat: string
) => {
  if (data instanceof Date) {
    return returnDate(data).format(outputFormat);
  }
  return returnDate(data, inputFormat).format(outputFormat);
};

export const getCalendarDate = (data: string) =>
  dayjsInstance(data).calendar(null, calendarDateFormat);

export const getSelectedTime = (parsedHour: number, parsedMinute: number) =>
  dayjsInstance().hour(parsedHour).minute(parsedMinute).second(0);

export const dayjs = dayjsInstance;
